import BaseService from '../../base/base_service';
import {SYSTEM_EVENTS} from '../../events/events';
import Store from '../../utils/store';
import {PENDING_ACTIONS} from './pending_action_consts';
import _ from '../../utils/underscore';
import Model from './pending_action_module';


class PendingActionService extends BaseService {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'PendingActionService';


    /**
     * @property
     * @type {null}
     * @private
     */
    _model = null;

    /**
     * Event that should trigger the pending action
     * @property
     * @type {Event}
     * @private
     */
    _triggerEvent = null;


    /**
     * Function should be called before action execution
     * @property
     * @type {Event}
     * @private
     */
    _preExecuteFunction = null;


    /**
     *
     * @param params
     */
    init(params) {
        super.init(params);
        this._model = Model.create(params);
        this._subscribe();
    }


    /**
     * Subscribe to ON_INIT_COMPLETE event on order to execute pending actions after back from redirect
     * @private
     */
    _subscribe() {
        this.onSystemEvent(SYSTEM_EVENTS.ON_INIT_COMPLETE, () => {
            this.executeAction();
        });
    }


    /**
     * Add peding action that should be executed later
     * @param action
     */
    addPendingAction(action) {
        if (_.isNullOrUndefined(action)) {
            return;
        }
        //subscribe to event triggers this action. Valid only in non-redirect context
        if (action.event) {
           this._triggerEvent = this.onSystemEvent(action.event, (data) => {
                this.executeAction(data);
            });
        }
        //save pre-execution function. Valid only in non-redirect context
         this._preExecuteFunction = _.isFunction(action.fn) ? action.fn : null;
         let actionData = {name: action.name, opt: action.options};
         if(action.persistent) {
             Store.set('pa', JSON.stringify(actionData));
         } else {
             this._inMemoryPendingAction = actionData;
         }

    }

    _inMemoryPendingAction = null;

    clearPendingAction() {
        Store.del('pa');
    }

    _getActionForExcecution() {
        if(this._inMemoryPendingAction) {
            return this._inMemoryPendingAction;
        }
        return _.safeJSON(Store.get('pa'));
    }

    /**
     * Execute stored pending action
     * Execution decided to three parts:
     * First - switch off the trigger event if it was defined
     * Second - call pre execution function. In some cases we will want to fulfill something before actual execution
     * Third - execute pending action itself
     * @private
     */
    executeAction() {
        //unsibscribe from trigger event
        if (this._triggerEvent) {
            this._triggerEvent.off();
            this._triggerEvent = null;
        }

        let action = this._getActionForExcecution();
        if (!action) {
            return;
        }

        Store.del('pa');
        this._inMemoryPendingAction = null;

        if (this._preExecuteFunction) {
            this._preExecuteFunction.call()
                .then(() => {
                    this._callAction(action);
                });
        } else {
            this._callAction(action);
        }
    }


    /**
     * Execute pending action
     * @param action
     * @private
     */
    _callAction(action) {
        switch (action.name) {
            case PENDING_ACTIONS.EXTERNAL_LINK:
                this._openExternalLink(action.opt);
                break;
            case PENDING_ACTIONS.GAME:
                this._openGame(action.opt);
                break;
            default:
                // maybe should throw an Exception here
                break;
        }
    }


    /**
     * Open pending game
     * @param params
     * @private
     */
    _openGame(params) {
        if(params.isReal) {
            this.serviceFactory.gameService().openRealGame(params);
        } else {
            this.serviceFactory.gameService().openAnonymousGame(params);
        }

    }


    /**
     * Open pending external link
     * @param params
     * @private
     */
    _openExternalLink(params) {
        this.serviceFactory.openLinkService().openLink(params);
    }

}

export default PendingActionService;